import { createSlice } from "@reduxjs/toolkit";

export const managerSlice = createSlice({
  name: "manager",
  initialState: {
    loading: false,
    managerList: [],
    listCount: 0,
    model: false,
    error_msg: null,
    rowdata: {},
    firmList: [],
    managerParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },
  reducers: {
    getManagers: (state) => ({ ...state, loading: true }),
    managerListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.managerParams.page_size,
      );
      return {
        ...state,
        listCount: action.payload.response.count,
        managerList: action.payload.response.results,
        loading: false,
        managerParams: { ...state.managerParams, no_of_pages: noofpages },
      };
    },
    managerAdd: (state) => ({ ...state, loading: true }),
    managerAddSuccessful: (state) => ({
      ...state,
      loading: false,
      model: false,
      rowdata: {},
    }),
    managerEdit: (state, action) => ({
      ...state,
      model: true,
      rowdata: action.payload,
    }),
    managerDelete: (state) => ({ ...state, loading: false }),
    InputChangeValue: (state, action) => ({
      ...state,
      rowdata: { ...state.rowdata, [action.payload.key]: action.payload.value },
    }),
    isModelVisible: (state, action) => {
      if (!action.payload) return { ...state, model: false, rowdata: {} };
      return { ...state, model: true };
    },
    SetManagerParams: (state, action) => ({
      ...state,
      managerParams: action.payload,
    }),
    getFirmList: (state) => state,
    firmListSuccessful: (state, action) => ({
      ...state,
      firmList: action.payload,
    }),
    apiError: (state, action) => ({
      ...state,
      loading: false,
      error_msg: action.payload,
    }),
  },
});

export const {
  getManagers,
  managerListSuccessful,
  managerAdd,
  managerAddSuccessful,
  managerEdit,
  managerDelete,
  InputChangeValue,
  isModelVisible,
  SetManagerParams,
  getFirmList,
  firmListSuccessful,
  apiError,
} = managerSlice.actions;

export default managerSlice.reducer;
